class MfaInputEvents {
    constructor(form) {
        const inputs = form.querySelectorAll('input.two-fa-input');
        if(inputs.length === 6){
            inputs[0].focus();
            inputs[0].addEventListener('paste', function(event) {
                // Stop data actually being pasted into input
                event.stopPropagation();
                event.preventDefault();

                let clipboardData = event.clipboardData || window.clipboardData;
                let pastedData = clipboardData.getData('Text');
                if(pastedData.length === 6){
                    for (let i = 0; i < 6; i++){
                        inputs[i].value = pastedData[i];
                    }
                    inputs[5].focus();
                }
            });

            for (let i = 0; i < inputs.length; i++) {
                inputs[i].addEventListener('keydown', function(event) {
                    if (event.key === "Backspace") {
                        inputs[i].value = '';
                        if (i !== 0)
                            inputs[i - 1].focus();
                    } else if (((event.keyCode > 47 && event.keyCode < 58) || (event.keyCode > 95 && event.keyCode < 106)) && !isNaN(event.key)) {
                        inputs[i].value = event.key;
                        if (i !== inputs.length - 1)
                            inputs[i + 1].focus();
                        event.preventDefault();
                    }
                });
            }
        }
    }
}
window.MfaInputEvents = MfaInputEvents;